// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SettingsOverlay.css */
.settings-menu {
  position: fixed;
  max-height: 95vh; /* Максимальная высота 90% от высоты экрана */
  overflow-y: auto; /* Добавляем вертикальную прокрутку при необходимости */
  
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  text-align: center;
  background-color: var(--tg-theme-bg-color);
  padding: 15px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  z-index: 1101;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.settings-menu * {
  touch-action: pan-y;
}

.settings-title {
  color: var(--tg-theme-button-color); /* Синий цвет */
  font-size: 24px;
  margin-bottom: 20px;
}


.settings-item {
  width: 100%;
  margin-bottom: 3px;
}

.settings-item:hover {
  background-color: rgba(154, 154, 154, 0.05);
}

.settings-menu input[type="checkbox"] {
  /* margin-right: 10px;
  accent-color: rgb(67, 67, 67); */
  width: 20px; 
  height: 20px; 
}


.settings-label {
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
  font-size: 15px;
  color: var(--tg-theme-text-color);
  padding: 1px; 
  padding-left: 10px; 
}

.settings-label-icon {
  width: 20px;
  height: 20px;
  vertical-align: middle;
  margin: 4px;
  margin-right: 10px;
}

input[type="checkbox"] {
  margin-right: 10px;
  accent-color:  rgb(67, 67, 67);
  width: 25px;
  height: 25px;
}

.settings-color-picker-container {
  position: fixed; /* или absolute, в зависимости от контекста */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1500; /* Убедитесь, что это значение выше, чем у других элементов */
}

.settings-color-indicator {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  margin-left: 1px;
  margin-right: 10px;
  border: 1px solid rgba(0, 0, 0, 0.2); /* Серая обводка, подходит к большинству цветов */
}

.divider {
  height: 1px;
  width: 100%;
  background: linear-gradient(to right, transparent, #ccc, #ccc, transparent);
  margin: 5px 0;
}`, "",{"version":3,"sources":["webpack://./src/components/menus/settings/SettingsOverlay.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,eAAe;EACf,gBAAgB,EAAE,6CAA6C;EAC/D,gBAAgB,EAAE,uDAAuD;;EAEzE,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC,EAAE,eAAe;EACpD,eAAe;EACf,mBAAmB;AACrB;;;AAGA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE;kCACgC;EAChC,WAAW;EACX,YAAY;AACd;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe,EAAE,6CAA6C;EAC9D,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa,EAAE,6DAA6D;AAC9E;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC,EAAE,iDAAiD;AACzF;;AAEA;EACE,WAAW;EACX,WAAW;EACX,2EAA2E;EAC3E,aAAa;AACf","sourcesContent":["/* SettingsOverlay.css */\r\n.settings-menu {\r\n  position: fixed;\r\n  max-height: 95vh; /* Максимальная высота 90% от высоты экрана */\r\n  overflow-y: auto; /* Добавляем вертикальную прокрутку при необходимости */\r\n  \r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 300px;\r\n  text-align: center;\r\n  background-color: var(--tg-theme-bg-color);\r\n  padding: 15px;\r\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);\r\n  border-radius: 12px;\r\n  z-index: 1101;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.settings-menu * {\r\n  touch-action: pan-y;\r\n}\r\n\r\n.settings-title {\r\n  color: var(--tg-theme-button-color); /* Синий цвет */\r\n  font-size: 24px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n\r\n.settings-item {\r\n  width: 100%;\r\n  margin-bottom: 3px;\r\n}\r\n\r\n.settings-item:hover {\r\n  background-color: rgba(154, 154, 154, 0.05);\r\n}\r\n\r\n.settings-menu input[type=\"checkbox\"] {\r\n  /* margin-right: 10px;\r\n  accent-color: rgb(67, 67, 67); */\r\n  width: 20px; \r\n  height: 20px; \r\n}\r\n\r\n\r\n.settings-label {\r\n  display: flex;\r\n  align-items: center;\r\n  width: 100%;\r\n  cursor: pointer;\r\n  font-size: 15px;\r\n  color: var(--tg-theme-text-color);\r\n  padding: 1px; \r\n  padding-left: 10px; \r\n}\r\n\r\n.settings-label-icon {\r\n  width: 20px;\r\n  height: 20px;\r\n  vertical-align: middle;\r\n  margin: 4px;\r\n  margin-right: 10px;\r\n}\r\n\r\ninput[type=\"checkbox\"] {\r\n  margin-right: 10px;\r\n  accent-color:  rgb(67, 67, 67);\r\n  width: 25px;\r\n  height: 25px;\r\n}\r\n\r\n.settings-color-picker-container {\r\n  position: fixed; /* или absolute, в зависимости от контекста */\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  z-index: 1500; /* Убедитесь, что это значение выше, чем у других элементов */\r\n}\r\n\r\n.settings-color-indicator {\r\n  width: 26px;\r\n  height: 26px;\r\n  border-radius: 50%;\r\n  margin-left: 1px;\r\n  margin-right: 10px;\r\n  border: 1px solid rgba(0, 0, 0, 0.2); /* Серая обводка, подходит к большинству цветов */\r\n}\r\n\r\n.divider {\r\n  height: 1px;\r\n  width: 100%;\r\n  background: linear-gradient(to right, transparent, #ccc, #ccc, transparent);\r\n  margin: 5px 0;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
